import { colors } from '@lmc/common/constants'
import { Button, EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { EmptyStateDescription } from '@lmc/ui-kit/src/dataDisplay/EmptyState'
import { getNominative } from 'common/utils'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const NotOnboarded = (props) => {
  const { openOnboardingModal, testId } = props
  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'
  const preferredPeopleNominative = useSelector(
    (state) => state.global.home.preferredPeopleNominative
  )
  const nominative = getNominative(
    preferredPeopleNominative,
    'service users'
  ).toLowerCase()

  //do we change this screen as well?

  return (
    <div
      style={styles.emptyStateWrapper}
      data-testid={
        testId ? `${testId}-emar-not-onboarded` : 'emar-not-onboarded'
      }
    >
      <div
        style={{
          ...styles.emptyStateImagesContainer,
          justifyContent: 'center'
        }}
      >
        <img
          alt=""
          src={
            'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/emar/emarheadericon.png'
          }
          style={{ margin: '0px 0px 16px', maxHeight: 100 }}
        />
      </div>
      <h2 style={styles.emptyStateTitle}>eMAR Module</h2>
      <div style={styles.emptyStateText}>
        <div>
          eMAR is a powerful electronic medication administration and recording
          tool that reduces the amount of time spent managing your {nominative}’
          medication needs. eMAR lets care Managers easily organise their{' '}
          {nominative}’ medication records digitally, safeguarding against
          illegible notes and missed signatures and making medication rounds a
          breeze.
        </div>
        <div>
          <a href={helpLink} target="_blank" rel="noreferrer">
            Learn more here
          </a>
        </div>
      </div>
      <Button
        id="open-emar-onboarding"
        onClick={() => openOnboardingModal()}
        style={{ marginBottom: 16 }}
        variant="primary"
        data-testid={testId ? `${testId}-emar-setup-btn` : 'emar-setup-btn'}
      >
        Set Up eMAR
      </Button>
      <div
        style={{
          fontSize: 12,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: 16
        }}
      >
        <div>You will be setting up:</div>
        <div>• Medication times and cycles for your care service</div>
        <div>• Which team members can sign medication</div>
      </div>
    </div>
  )
}

export default function EMARScreenEmptyState(props) {
  const {
    displayArrow = true,
    emarOnboarded,
    resident: { name, preferredName },
    testId
  } = props

  if (!emarOnboarded) return <NotOnboarded {...props} />

  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'

  const labelStyle = {
    ...styles.emptyStateArrowLabel,
    visibility: displayArrow ? 'visible' : 'hidden'
  }

  return (
    <div
      style={styles.emptyStateWrapper}
      data-testid={testId ? `${testId}-emar-empty-state` : 'emar-empty-state'}
    >
      <EmptyState
        icon={<NoDataIcon />}
        title={`${preferredName || name.first} has no medications yet`}
        description={
          <EmptyStateDescription>
            Learn more about adding a medication{' '}
            <a href={helpLink} target="_blank" rel="noreferrer">
              here
            </a>
            .
          </EmptyStateDescription>
        }
        data-testid={
          testId
            ? `${testId}-emar-no-medications-empty-state`
            : 'emar-no-medications-empty-state'
        }
      />
    </div>
  )
}

EMARScreenEmptyState.propTypes = {
  displayArrow: PropTypes.bool,
  emarOnboarded: PropTypes.bool,
  openOnboardingModal: PropTypes.func,
  resident: PropTypes.object.isRequired,
  testId: PropTypes.string
}

const styles = {
  emptyStateArrowLabel: {
    marginRight: 35,
    maxWidth: 135
  },
  emptyStateDino: {
    margin: '25px 0px 30px',
    maxHeight: 165
  },
  emptyStateImagesContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12,
    width: '100%'
  },
  emptyStateText: {
    lineHeight: '22px',
    maxWidth: 700,
    marginBottom: 35,
    textAlign: 'center'
  },
  emptyStateTitle: {
    lineHeight: '36px'
  },
  emptyStateWrapper: {
    alignItems: 'center',
    background: colors.white,
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    width: '100%',
    padding: 22
  }
}
